"use strict";
/*
 * Created on 11 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProductSiteBinding_1 = require("../model/ProductSiteBinding");

var ProductSiteBindingConverter_1 = require("./ProductSiteBindingConverter");
/**
 * Implementation of {@link ProductSiteBindingConverter}
 *
 * @author JMe
 */


var ProductSiteBindingConverterImpl =
/*#__PURE__*/
function (_ProductSiteBindingCo) {
  _inherits(ProductSiteBindingConverterImpl, _ProductSiteBindingCo);

  function ProductSiteBindingConverterImpl() {
    _classCallCheck(this, ProductSiteBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteBindingConverterImpl).apply(this, arguments));
  }

  _createClass(ProductSiteBindingConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductSiteBinding_1.ProductSiteBinding(ProductSiteBinding_1.ProductSiteBinding.schema.id.valueOf(conversions.documentToClassId(source)), ProductSiteBinding_1.ProductSiteBinding.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), ProductSiteBinding_1.ProductSiteBinding.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), ProductSiteBinding_1.ProductSiteBinding.schema.validFrom.valueOf(conversions.asObject(source, 'validFrom', function (value) {
        return conversions.toDate(value);
      })), ProductSiteBinding_1.ProductSiteBinding.schema.validTo.valueOf(conversions.asObject(source, 'validTo', function (value) {
        return conversions.toDate(value);
      })), ProductSiteBinding_1.ProductSiteBinding.schema.processed.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        productId: conversions.toDocumentReferenceId(source.productId),
        siteId: conversions.toDocumentReferenceId(source.siteId),
        validFrom: conversions.fromDate(source.validFrom),
        validTo: conversions.fromDate(source.validTo),
        processed: source.processed
      });
      return document;
    }
  }]);

  return ProductSiteBindingConverterImpl;
}(ProductSiteBindingConverter_1.ProductSiteBindingConverter);

exports.ProductSiteBindingConverterImpl = ProductSiteBindingConverterImpl;